import { render, staticRenderFns } from "./TaskManage.vue?vue&type=template&id=06d2e3be&scoped=true"
import script from "./TaskManage.vue?vue&type=script&lang=js"
export * from "./TaskManage.vue?vue&type=script&lang=js"
import style0 from "./TaskManage.vue?vue&type=style&index=0&id=06d2e3be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d2e3be",
  null
  
)

export default component.exports